/**
 *   Created by FANGlh on 2018/11/9 20:09.
 */

import React, {Component} from 'react';
import './AccessNotice.css';
import {fetchPost, fetchGet, fetchGetNoSession} from '../../../utils/fetchRequest';
import {_baseURL, API} from '../../../configs/api.config';
import LoadingMore from "../../../components/LoadingMore";
import InfiniteScroll from 'react-infinite-scroller';
import {Toast} from 'antd-mobile';
import {connect} from 'react-redux';
import ItemComp from './ItemComp';
import {Avatar} from 'antd'
import {getIntValue, getStrValue, isObjEmpty,getSearchParams} from "../../../utils/common";

class AccessNotice extends Component {
    componentWillMount() {
        document.title = '出入校通知'
    }

    constructor() {
        super();
        this.state = {
            studentName: '',
            studentGrade: '',
            out_inData: [],
            stuPhoto: '',
        }
    }

    componentDidMount() {
        this.searchParams = getSearchParams(this.props.location.search)
        let stuId = this.props.userInfo.user.student.stuId
        if (this.searchParams && this.searchParams.stuId) {
            stuId = this.searchParams.stuId
        }
        this.setState({
            studentName: this.props.userInfo.user.student.stuName,
        })
        fetchPost(API.RecordOutgoingList, {
            stuId: stuId,
            // stuId:10138,
            pageIndex: 1,
            pageSize: 10
        }).then((response) => {
            if (response.success && response.data && response.data.outInRecordDOS.length > 0) {
                if (response.data.student) {
                    this.setState({
                        studentName: response.data.student.stuName,
                        studentGrade: response.data.student.gradeName + response.data.student.clazzName,
                        stuPhoto: response.data.student.stuPhoto
                    })
                }

                this.setState({
                    out_inData: response.data.outInRecordDOS
                })
            } else {
                Toast.info("暂无您孩子的最新出入校数据，谢谢！", 2)
            }
        }).catch((error) => {
            console.log('error', error)
            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('请求异常', 2)
            }
        })
    }

    render() {
        const  NoticeItems = []
        if (this.state.out_inData){
            this.state.out_inData.forEach((itemata, index) => {
                let isFirst = false
                let isLast = false
                if (index === 0) {
                    isFirst = true
                    isLast = false
                }
                if (index === (this.state.out_inData.length - 1)) {
                    isFirst = false
                    isLast = true
                }
                NoticeItems.push(<ItemComp key={index} itemdata={itemata}
                                           handelSItem={this.handelSItem}
                                         isFirst={isFirst} isLast={isLast}/>)

            })
        }
        return (
           <div className="an_contain">
               <div className="header_sty">
                   {this.state.stuPhoto ?
                       <img className="img-circle header"
                            src={this.state.stuPhoto}
                            alt=""/> :
                       <div className='header'>
                           <Avatar size={50} icon='user'/>
                       </div>}

                   <div style={{marginTop: 20,display:"flex",flexDirection:"row"}}>
                       <div style={{color: "#FFF", fontSize: 18}}>{this.state.studentName}</div>
                       <div style={{color: "#FFF", fontSize: 12, marginTop: 5,marginLeft:10}}>{this.state.studentGrade}</div>
                   </div>
               </div>

               {
                   this.state.out_inData.length > 0 ?
                       <div className="av_items">
                           <div style={{marginBottom: 50, marginLeft: 50,marginTop:50,}}>
                               {NoticeItems}
                           </div>
                       </div> : ''
               }

           </div>
        )
    }

    HttpTest = () => {
        // httpRuquest.
    }
    previousDataClick = (event) => {
        console.log('previousDataClick')
    }

    nextDataClick = (event) => {
        console.log('nextDataClick')
    }
}

let mapStateToProps = (state) => ({
    userInfo: {...state.redUserInfo}
})

let mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(AccessNotice)